//@flow
import React from 'react';
import ReactSidebar from 'react-sidebar';

type Props = {
  open:boolean,
  onSetOpen:() => void,
  pullRight?:boolean,
  children?:React$Node,
  sidebar:?React$Node,
};

function _getStyles() {
  return {
    root: { position: 'static' },
    sidebar: { position: 'fixed', zIndex: 102, overflow: 'hidden' },
    content: { position: 'static', overflow: 'visible', overflowY: 'visible' }, // overflowY is IE fix
    overlay: { zIndex: 101 },
  };
}


export default function Sidebar(props:Props) {
  return (
    <ReactSidebar
      sidebarClassName="sidebar-content"
      rootClassName="sidebar-wrapper"
      sidebar={props.sidebar}
      open={props.open}
      onSetOpen={props.onSetOpen}
      styles={_getStyles()}
      touch={false}
      pullRight={props.pullRight}
    >
      {props.children}
    </ReactSidebar>
  );
}
